export default __webpack_public_path__ + "static/media/group.0c169b5e.svg";